import { zonedTimeToUtc } from "date-fns-tz";

export const DateFormate = (newDate) => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const d = new Date(newDate);
  // const month = d.getMonth();
  const month = Number(newDate?.split("-")[1]);
  // const date = d.getDate();
  const date = newDate ? newDate.split("-")[2] : "";
  const year = d.getFullYear();

  return monthNames[month - 1]
    ? monthNames[month - 1] + " " + date + ", " + year
    : "---";
};

export const DateFormate2 = (newDate) => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const d = new Date(newDate);
  const month = d.getMonth();
  // const date = d.getDate();
  let date = newDate ? newDate.split("-")[2] : "";
  if (date && date[0] === "0") {
    date = date.replace(date[0], "");
  }
  const year = d.getFullYear();

  return monthNames[month]
    ? monthNames[month] + " " + date + ", " + year
    : "---";
};

export const DateSet = (date) => {
  if (date) {
    var dateAsString = date;
    var year = dateAsString.split("-")[0];
    var month = dateAsString.split("-")[1];
    var day = dateAsString.split("-")[2];
    var newDate = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
    newDate.setTime(
      newDate.getTime() + newDate.getTimezoneOffset() * 60 * 1000
    );
  }

  return date !== undefined ? newDate : "";
};

export const TimeZone = (date) => {
  const myDate = new Date(date);
  const newDate = zonedTimeToUtc(
    myDate,
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );

  return date !== undefined ? newDate : "";
};

export const DateConverter = (date) => {
  let currDate = date;
  const day = currDate?.getDate();
  let month = currDate?.getMonth() + 1;
  const year = currDate?.getFullYear();

  if (month === 13) month = 1;

  const newMonth = month < 10 ? "0" + month : month;
  const newDay = day < 10 ? "0" + day : day;

  const newDate = year + "-" + newMonth + "-" + newDay;

  return newDate;
};

export const TimeConverter = (time) => {
  const newTime = time.split(",")[1];
  return newTime
    .toLocaleTimeString(navigator.language, {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
    .split(" ")[0];
};

export const DateConverterWithTime = (dt) => {
  const newDate = new Date(dt);

  return newDate?.toLocaleTimeString() + ", " + newDate?.toDateString();
};
